<template>
    <div class="noticias">
        <v-container>
            <v-layout row>
                <v-flex md9 xs12>
                    <Noticias />
                </v-flex>
                <v-flex md3 xs12>
                    <Servicios />
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
const Noticias = () => import('@/components/Noticias.vue')
const Servicios = () => import('@/components/Servicios.vue')

export default {
    name: 'NoticiasGeneral',
    components: {
        Noticias,
        Servicios
    },
}
</script>
